<template>
  <div
    class="flex cursor-pointer flex-row items-center p-24"
    :class="{
      'border-b-static-default-low border-b-1': hasSeparator,
    }"
    data-qa="select-your-orderline-order-item"
    data-test="select-your-orderline-order-item"
    role="button"
    tabindex="0"
    @click="handleAction"
    @keydown="handleAction"
  >
    <RevIllustration :alt="title" :height="72" :src="image" :width="72" />
    <div class="ml-8 grow">
      <h3 class="body-1-bold">
        {{ title }}
      </h3>
      <p class="text-static-default-low body-2">
        {{ subtitle }}
      </p>
    </div>
    <IconChevronRight />
  </div>
</template>

<script setup lang="ts">
import { navigateTo, useRouteLocationWithLocale } from '#imports'
import type { RouteLocationRaw } from 'vue-router'

import { RevIllustration } from '@ds/components/Illustration'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import type { OrderlineLinkedOrderItemAction } from '~/api/my-orders/types/OrderlineLinkedOrderItems.types'
import { CUSTOMER_CONVERSATION } from '~/scopes/customer-conversation/route-names'

interface SelectYourOrderlineOrderItemProps {
  title: string
  subtitle: string
  image: string
  action: OrderlineLinkedOrderItemAction
  hasSeparator?: boolean
}

const emit = defineEmits<{
  'show-conversation': [ticketId: string]
}>()

const { action } = defineProps<SelectYourOrderlineOrderItemProps>()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const handleAction = async () => {
  if (action.link.type === 'internal') {
    const { hash, ...link } = action.link

    if (link.name === 'select_your_orderline') {
      const ticketId = link.query?.intercom_ticket_id
      if (ticketId) {
        emit('show-conversation', ticketId)
      }

      return
    }

    // We have to replace the link name for ASP conversation as the one from my-orders is incorrect
    await navigateTo(
      resolveLocalizedRoute({
        ...link,
        name:
          link.name === 'join_conversation'
            ? CUSTOMER_CONVERSATION.RESOLUTION
            : link.name,
        // We want to navigate even if the location is the same
        force: true,
      }) as RouteLocationRaw,
    )
  }
}
</script>
